import React from 'react';
import { getSection } from './saleReportHelpers';

// จัดการรายงาน modal — report-level date range + delivery-checker/routine triggers.
// Gated by `showManageCard && fullReport` in the container, same as before this split.
const ManageActionsModal = ({
    fullReport,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    loadingDelivery,
    loadingRoutine,
    fetchDeliveryChecker,
    handleTriggerRoutine,
    onClose,
}) => {
    return (
        <div style={{
            position: 'fixed',
            top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            zIndex: 1000
        }}>
            <div className="btc-card" style={{ width: '400px', padding: '20px', position: 'relative' }}>
                <button
                    onClick={onClose}
                    style={{ position: 'absolute', top: '10px', right: '10px', border: 'none', background: 'none', fontSize: '20px', cursor: 'pointer' }}
                >
                    &times;
                </button>
                <h3>จัดการรายงาน</h3>
                {(() => {
                    const master = getSection(fullReport, ['master', 'masterReport', 'report', 'masterData'], null);
                    if (!master) return <p>ไม่พบข้อมูลมาสเตอร์</p>;
                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '10px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <label style={{ width: '60px' }}>เริ่ม:</label>
                                <input
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    style={{ flex: 1, padding: '5px' }}
                                />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <label style={{ width: '60px' }}>ถึง:</label>
                                <input
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    style={{ flex: 1, padding: '5px' }}
                                />
                            </div>

                            <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                                <button
                                    className="btc-btn"
                                    style={{ flex: 1, backgroundColor: "#46af38" }}
                                    onClick={() => fetchDeliveryChecker(master.sellerId, startDate)}
                                    disabled={loadingDelivery}
                                >
                                    {loadingDelivery ? '...' : 'Check Delivery'}
                                </button>
                                <button
                                    className="btc-btn"
                                    style={{ flex: 1, backgroundColor: "#007bff" }}
                                    onClick={() => handleTriggerRoutine(master.sellerId, startDate, endDate)}
                                    disabled={loadingRoutine}
                                >
                                    {loadingRoutine ? '...' : 'Fetch Routine'}
                                </button>
                            </div>
                            <button
                                className="btc-btn"
                                style={{ backgroundColor: "#6c757d", marginTop: '10px' }}
                                onClick={onClose}
                            >
                                ปิด
                            </button>
                        </div>
                    );
                })()}
            </div>
        </div>
    );
};

export default ManageActionsModal;
